export enum RequestTypes {
  null,
  text = "text",
  email = "email",
  print = "print",
}

export interface CardRequest {
  request_type: number;
  recipient: string;
  group_number: string;
}

export interface CardResponse {
  message: string;
  print_url: string;
  loading: true;
}

export interface ModalProps {
  type: RequestTypes;
  visible: boolean;
  onClose: () => void;
}

export type Params = {
  group_number?: string | null;
  url_params_group_number?: string;
  cleint?: string | null;
};

export interface CloseModalProp {
  onClose: () => void;
}
